<section class="flex flex-col w-full us-address">
  <div class="wrapper">
    <div class="title mb-8 md:mb-8 lg:mb-10">
      <h1>{{ 'okeeyCash.USAddress' | translate }}</h1>
    </div>
    <div class="subtitle mb-10 md:mb-8 lg:mb-10">
      <span
        >{{ 'okeeyCash.youCanHaveYourCard' | translate }}
        <span class="subtitle-bold">{{ 'okeeyCash.standardUSFormat' | translate }}</span
        >.</span
      >
    </div>
    <div class="examples mb-6 md:mb-6 lg:mb-12">
      <div class="wrong">
        <img src="../../../../../../assets/img/my-okeey-cash/wrong-address.svg" />
        <span>02109, St Fe, 15 Regency Pl.</span>
      </div>
      <div class="correct">
        <img src="../../../../../../assets/img/my-okeey-cash/correct-address.svg" />
        <span>15 Regency Pl., Santa Fe, NM, 02109</span>
      </div>
    </div>
    <div class="validate-your-address mb-10 md:mb-12">
      <a (click)="onValidateAddressClick()">{{ 'okeeyCash.validateYourAddressHere' | translate }}</a>
    </div>
    <div class="remember mb-6 md:mb-8">
      <span
        >{{ 'okeeyCash.rememberPO' | translate }}
        <span class="remember-bold">{{ 'okeeyCash.mustMatchTheBill' | translate }}</span></span
      >
    </div>
  </div>
</section>
